import React, { useCallback } from "react";

import Form from "../Components/SmartForm/Form";
import Input from  "../Components/SmartForm/Input";
import Label from "../Components/SmartForm/Label";

const ResetPasswordForm = (props) => {
    const validatePasswordsMatch = useCallback((value, form) => {
        if (value !== form.elements["password"].value) {
            return "Passwords must match";
        }
    }, []);

    return (
        <Form
            id="reset-password-form"
            action="/customer/account/createPassword"
            method="post"
            {...props}
        >
            <div className="col-12">
                <Label
                    input="password"
                    required
                >
                    New Password
                </Label>
                <Input
                    type="password"
                    name="password"
                    label="New Password"
                    className="form-control"
                    required
                />
            </div>
            <div className="col-12">
                <Label
                    input="password-confirm"
                    required
                >
                    Confirm Password
                </Label>
                <Input
                    type="password"
                    name="password-confirm"
                    label="Confirm Password"
                    className="form-control"
                    validation={validatePasswordsMatch}
                    required
                />
            </div>
            <Input type="hidden" name="id" />
            <Input type="hidden" name="token" />
            <button className="btn btn-lx">
                <i className="fas fa-lock-alt" />
                <span>Submit</span>
            </button>
        </Form>
    );
};

export default ResetPasswordForm;
